import { FilterType } from "./CustomerFilter";
import { SelectOption } from "./Form";

export enum CustomerListFilterFilterType {
  All = "All",
  Specific = "specific",
  Segments = "segments",
}

/**
 * @deprecated Legacy enum - use Custom Filter with __optInDate field instead
 */
export enum AllCustomerFilterDateRangeType {
  AllTime = "all",
  OptInDate = "optInDate",
  BookingDate = "bookingDate",
}

/**
 * CustomerListFilter is simplified to either
 * Specific Customers list (Via search lookup)
 * or With selected Marketing Segments and Tags
 * Example:
 *   John Doe restaurantMarketingSegment.restaurantId includes `1234abcd`, tags.categoryId contains 'Smoker'
 *   Jane Doe restaurantMarketingSegment.restaurantId includes `1234abcd`, tags.categoryId does not contain 'Smoker'
 *   CustomerListFilter.tagIds contains `Smoker`
 *   CustomerListFilter.customerSegmentIds contains `1234abcd`
 *   result list will contain Jane but NOT John
 * NET customer list is unique customers that match selected customerSegmentIds MINUS all those with selected tagIds
 *
 * Note: Restaurant selection is now handled at the parent form level (e.g., Newsletter.restaurantId). Multiple restaurants is not supported
 */
export interface CustomerListFilter {
  /** Specific or segment */
  filterType?: CustomerListFilterFilterType;
  /** Array of specific Customers pick */
  specificCustomerObjects?: SelectOption[];
  /** Array of Customer Tag IDs. This is use for exclusion */
  tagIds?: string[];
  /** Array of Customer Segment IDs to apply for inclusion */
  customerSegmentIds?: string[];
  /**
   * Denotes exclude customers who have already been actioned upon based on given CustomerListFilter
   * Example:
   * Job is scheduled to run every day at 9am that targets customers who visited exactly 2 times with Bottomless brunch mennu
   * Each day the job only targets fresh set of customers that match aobve segment
   */
  /**
   * @deprecated Moved to top-level AutomationJob.uniqueChortsOnly so it applies to all trigger types.
   * Kept for backwards compatibility with jobs saved before the move.
   */
  uniqueChortsOnly?: boolean;

  /** @deprecated Use customerSegmentIds instead - kept for backwards compatibility */
  customFilterIds?: string[];
  /** @deprecated Use customerSegmentIds instead - kept for backwards compatibility */
  customFilterId?: string;
  /** @deprecated Legacy field - restaurants now comes from parent form's restaurantId */
  restaurants?: string[];
  /** @deprecated Legacy field */
  allTime?: boolean;
  /** @deprecated Legacy field */
  dateFrom?: string;
  /** @deprecated Legacy field */
  dateTo?: string;
  /** @deprecated Legacy field for All filter type */
  allCustomerDateRangeType?: AllCustomerFilterDateRangeType;
}

/**
 * @deprecated Use CustomerListFilter with customFilterIds instead
 */
export interface SpecificCustomerListFilter extends CustomerListFilter {
  filterType: CustomerListFilterFilterType.Specific;
  specificCustomerObjects: { label: string; value: string }[];
}

/**
 * @deprecated Use CustomerListFilter with customFilterIds instead
 */
export interface CustomCustomerListFilter extends CustomerListFilter {
  filterType: CustomerListFilterFilterType.Segments;
  customFilterId: string;
}

/**
 * @deprecated Use CustomerListFilter with customFilterIds instead
 */
export interface AllCustomerListFilter extends CustomerListFilter {
  filterType: CustomerListFilterFilterType.All;
  allCustomerDateRangeType: AllCustomerFilterDateRangeType;
}

export const DateRangeRequiredFilter = [
  FilterType.Purchases, //
  FilterType.MenuBooked,
  FilterType.Occassions,
  FilterType.Visits,
  FilterType.FirstTimeCustomer,
  FilterType.GuestNeverBooked,
  FilterType.NoShows,
  FilterType.Cancellations,
  FilterType.Waitlists,
  FilterType.Custom,
];
